import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Countdown from "react-countdown";

const PsikotesNavbar = ({ timer, start, page }) => {
  const navigate = useNavigate();
  const [deadline, setDeadline] = useState(null);

  const renderer = ({ minutes, seconds, completed }) => {
    if (completed) return <span>00:00</span>;

    return (
      <span>
        {String(minutes).padStart(2, "0")}:{String(seconds).padStart(2, "0")}
      </span>
    );
  };

  useEffect(() => {
    if (!timer) return;

    setDeadline(Date.now() + timer);
  }, [timer]);

  const handleComplete = () => {
    if (page === "disc") navigate("/msdt");
    else if (page === "msdt") navigate("/istse");
    else if (page === "istse") navigate("/istwa");
    else if (page === "istwa") navigate("/istan");
    else if (page === "istan") navigate("/istge");
    else if (page === "istge") navigate("/istra");
    else if (page === "istra") navigate("/istzr");
    else if (page === "istzr") navigate("/istfa");
    else if (page === "istfa") navigate("/istwu");
    else if (page === "istwu") navigate("/istme");
    else navigate("/psikotes-end");
  };

  return (
    <>
      <div className="navbar  bg-[#F2F2F2] pr-5 pl-5 sm:pr-5 sm:pl-5 md:pr-10 md:pl-10 lg:px-14">
        <a className="normal-case text-xl">
          <img src="/logo-estprima.png" className="w-28" />
          <p className="text-black ml-6 sm:flex md:flex lg:flex xl:flex">
            PSIKOTES ONLINE
          </p>
        </a>

        <p className="text-xl ml-auto font-mono text-red-500 flex gap-2 items-center">
          <p>Sisa Waktu :</p>
          {start ? (
            <Countdown
              date={deadline}
              renderer={renderer}
              onComplete={handleComplete}
            />
          ) : (
            "00:00"
          )}
        </p>
      </div>
    </>
  );
};

export default PsikotesNavbar;
